<template>
  <button class="wish-list-btn"
          :class="{'wish-list-btn--active': isInWishList, 'is-product-page': productPage}"
          type="button"
          ref="addToWishList"
          @click="changeWishListStatus"
          :title="isInWishList ? $t('in.wishlist') : $t('to.wishlist')"
  >
    <div class="wish-list-btn__wrap">
      <div class="wish-list-btn__svg-wrap">
        <svg class="wish-list-btn__svg"
             width="25"
             height="25"
             fill="none">
          <use :xlink:href="spritePath + '#wishlist'"></use>
        </svg>
      </div>
      <!--      <span class="wish-list-btn__text">-->
      <!--        {{ isInWishList ? $t('in.wishlist') : $t('to.wishlist') }}-->
      <!--      </span>-->
    </div>
  </button>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { spritePath } from '@/mixins/spritePath'
import { GoogleEnhancedEcommerce } from '@/services/AnalyticService'

export default {
  name: 'WishListBtn',
  mixins: [spritePath],
  data () {
    return {
      isWishlistLoading: false
    }
  },
  props: {
    id: Number,
    inWishListStatus: {
      type: Boolean,
      default: false
    },
    price: {
      type: Number
    },
    isInStock: {
      type: Boolean
    },
    showText: {
      type: Boolean,
      default: false
    },
    productPage: {
      type: Boolean,
      default: false
    },
    code: [Number, String],
    analyticsData: Array
  },
  methods: {
    ...mapActions('wishlist', ['CHANGE_WISH_LIST_STATUS']),
    changeWishListStatus () {
      if (this.user && this.user.auth) {
        this.isWishlistLoading = true

        this.CHANGE_WISH_LIST_STATUS({
          id: this.id,
          price: this.price || '0',
          isInStock: this.isInStock,
          code: this.code
        })
          .then(response => {
            this.notifySuccess(response.message)
            if (GoogleEnhancedEcommerce.isEnabled) {
              GoogleEnhancedEcommerce.addToWishlist({
                value: +GoogleEnhancedEcommerce.getGoogleEnhancedEcommerceData(this.analyticsData[0]).price * parseInt(GoogleEnhancedEcommerce.getGoogleEnhancedEcommerceData(this.analyticsData[0]).quantity || 1),
                universal_value: this.isInWishList ? 'add' : 'removed',
                items: [GoogleEnhancedEcommerce.getGoogleEnhancedEcommerceData(this.analyticsData[0])]
              })
            }
          })
          .catch(error => this.notifyError(error))
          // eslint-disable-next-line no-return-assign
          .finally(() => this.isWishlistLoading = false)
      } else {
        window.addEventListener('wishListTrigger', () => {
          if (!this.isInWishList) this.changeWishListStatus()
        })

        this.$modal.show('auth-modal', {
          title: this.$t('wishlist.auth'),
          isAjaxAuth: true,
          referrer: 'wish-list'
        })
      }
    },
    notifySuccess (message) {
      this.$notify({
        group: 'success',
        title: '',
        text: message,
        type: 'success'
      })
    },
    notifyError (message) {
      this.$notify({
        group: 'error',
        title: this.$t('error'),
        text: message,
        type: 'error'
      })
    }
  },
  computed: {
    ...mapGetters(['urlLanguagePrefix']),
    ...mapGetters('wishlist', ['productsIdsInWishlist']),
    ...mapState({
      user: state => state.user
    }),
    isInWishList () {
      if (this.productsIdsInWishlist) {
        return this.productsIdsInWishlist.includes(this.id)
      }

      return false
    }
  }
}
</script>

<style lang="sass" scoped>

.wish-list-btn
  background-color: transparent
  border: 0
  padding: 0

  &:hover .wish-list-btn__svg,
  &:focus .wish-list-btn__svg
    stroke: $main-color

  &--active .wish-list-btn__svg
    fill: $main-color
    stroke: $main-color

.wish-list-btn__svg
  stroke: #909090
  stroke-width: 2px
  vertical-align: middle

  transition: .1s ease-in-out stroke, .1s ease-in-out fill

.wish-list-btn__text
  display: block
  margin-top: 9px
  color: $placeholder-color
  font-weight: 400
  font-size: 11px
  line-height: 13px
  min-width: 70px

.product-card__wish-list-btn
  display: flex
  align-items: center

  +mmin($tablet)
    background-color: #F8F8F8
    border-radius: 3px
    padding: 5px

    &:hover
      background-color: #E7E7E7

  &:hover .wish-list-btn__svg
    stroke: $text-color

  .wish-list-btn__svg
    stroke: $text-color

.product-card .product-card__wish-list-btn.wish-list-btn--active
  &:hover .wish-list-btn__svg
    stroke: $main-color

  .wish-list-btn__svg
    stroke: $main-color

.product-card__wish-list-btn .wish-list-btn__text
  min-width: auto
  font-size: 12px
  line-height: 14px
  stroke: #cccccc
  margin-top: 0
  margin-left: 10px

  +mmin($tablet)
    display: none

.product-card--not--adaptive
  .product-card__wish-list-btn
    background-color: #F8F8F8
    border-radius: 3px
    padding: 5px

    &:hover
      background-color: #E7E7E7

  .wish-list-btn__text
    display: none

.wish-list-btn__wrap
  display: flex
  align-items: center
  justify-content: center

.is-product-page
  justify-content: center
  width: 50%
  background-color: #F8F8F8
  height: 46px
  margin-left: 0

  .wish-list-btn__text
    display: block
    font-size: 14px
    color: $text-color
    margin: 0 0 0 10px

.product-actions__btn--wish-list
  +mmax(768)
    height: 50px

  +mmin($tablet)
    display: flex
    align-items: center
    width: auto
    background-color: transparent
    //padding: 0 10px

  .wish-list-btn__text
    +mmin($tablet--hor)
      display: none

    +mmin(1360)
      display: block

  .wish-list-btn__svg-wrap
    +mmin($tablet)
      display: flex
      justify-content: center
      align-items: center
      padding: 11px 10.5px
      background-color: #f8f8f8
      border-radius: 3px
.product-card__info
  .wish-list-btn__svg
    width: 18px
    height: 18px
</style>
